<div class="texteditor">
  <div class="NgxEditor__Wrapper">
    <ngx-editor-menu
      [editor]="editor"
      [toolbar]="toolbar"
      [disabled]="disabled || readonly"
      [ngStyle]="{
        pointerEvents: isTextEditorDisabled ? 'none' : 'auto'
      }"
    >
    </ngx-editor-menu>
    <ngx-editor
      [editor]="editor"
      [(ngModel)]="_editorValue"
      [disabled]="readonly"
      [placeholder]="'Type Here...'"
      (click)="enableEdit($event)"
      [ngClass]="{ 'NgxEditor__Wrapper__text-editor-read-only': readonly }"
    ></ngx-editor>
  </div>
</div>
